module.exports = __webpack_public_path__ + "static/media/mindset_shift_v2.74c5e0a9.webp";